import {MakeExamsConfirmParams} from 'domain/usecases';
import {makePostExamBooking} from 'main/factories/usecases';

export async function postExamBooking(params: MakeExamsConfirmParams) {
	const response = await makePostExamBooking().post(params);

	return response;
}
